import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { SettingsService } from "../../services/settings.service";
import { ISettings } from "../../models/Settings";
import { IMaintenanceSettings } from "../../models/MaintenanceSettings";

export const useGetSettingsQuery = () => {
  return useQuery<ISettings, Error>({
    queryKey: [QUERY_CONSTANTS.GET_SETTINGS],
    queryFn: () => SettingsService.getSettings().then((res) => res.data),
  });
};

export const useGetMaintenanceSettingsQuery = () => {
  return useQuery<IMaintenanceSettings, Error>({
    queryKey: [QUERY_CONSTANTS.GET_MAINTENANCE_SETTINGS],
    queryFn: () => SettingsService.getMaintenanceSettings().then((res) => res.data),
  });
};
